/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
const host = 'exab-training.com'
const ApiHost = 'api.exab-training.com';
const protocol = 'https';
const portalSubDomain = 'portal';
const adminSubDomain = 'admin';
const domain = `${protocol}://${ApiHost}`;
const mediaUrl = `${domain}/storage/media/`;
const adfsClientId = '32531b31-908f-4996-950b-bba797fee97b';

export const environment = {
  production: false,
  apiUrl: domain,
  notificationHubUrl: `wss://${ApiHost}/hub/notifications`,
  showProcedures: false,
  mohFeatures: false,
  showActiveDirectory: false,
  mediaUrl: mediaUrl,
  firebase: {
      apiKey: "AIzaSyCy_ma-F7JIATlnfZ6OrRtYeqr5sP1R_n4",
      authDomain: "exaab-ccb44.firebaseapp.com",
      projectId: "exaab-ccb44",
      storageBucket: "exaab-ccb44.appspot.com",
      messagingSenderId: "725665320337",
      appId: "1:725665320337:web:541a1c00aa7a3da83c5e30"
  },
  translateUrl: `${domain}/Settings/culture/translate/`,
  courseResource: mediaUrl,
  programResource: mediaUrl,
  contentResource: mediaUrl,
  learningPathResource: mediaUrl,
  userResource: mediaUrl,
  identityResource: mediaUrl,
  certificateResource: mediaUrl,
  homeImageResource: mediaUrl,
  testimonialResource: mediaUrl,
  partnerResource: mediaUrl,
  examResource: mediaUrl,
  allowCredentials: false,
  zoom: {
    zoomSdkKey :'NiRkqoyzQqSU_hw9fHSQzw',
    zoomSdkSecret : 'G5gbS3aozPhacHnn8B8m4kXgmnIdxSfo', 
  },
  routingAuthentication: `${protocol}://${portalSubDomain}.${host}/auth/login`,
  dashboardUrl: `${protocol}://${adminSubDomain}.${host}`,
  courseDetailsUrl: `${protocol}://${host}/course/details/`,
  scormUrl: `${domain}/course-resources/degaScormPlayer?path=`,
  header: {
    headers: {
      'Content-Type': 'application/json',
    },
  },
  enableAdfs: true,
  adfs: {
    redirectUrl: "https://exaab.tamkeentecs.com/home",
    clientId: "32531b31-908f-4996-950b-bba797fee97b",
    authorization_endpoint: 'https://sts.moh.gov.sa/adfs/oauth2/authorize/',
    issuer: "https://sts.moh.gov.sa/adfs",
    scopes_supported: 'email openid profile',
    response_types_supported: 'id_token token',
    token_endpoint: 'https://sts.moh.gov.sa/adfs/oauth2/token/',
    end_session_endpoint: 'https://sts.moh.gov.sa/adfs/oauth2/logout'
  },
  adfsStaticLink: `https://sts.moh.gov.sa/adfs/ls/?client-request-id=${adfsClientId}&wa=wsignin1.0&wtrealm=http%3A%2F%2F185.100.235.211%2Fhome`,
};